import styled from '@emotion/styled';

const ParagraphTitle = styled('h2')({
  marginBottom: '0.25rem',
});

export default ParagraphTitle;
